// ---------- Store Rules (Pegasus) ------------
import { z } from 'zod';
import { enumToZodLiteralUnion, helperSchema } from '../../zodExtensions.js';
import { Pegasus } from './pegasus.js';
export const storeRule = z.object({
    id: z.number(),
    isEnabled: z.boolean(),
    name: helperSchema.nonEmptyString,
    hook: enumToZodLiteralUnion(Pegasus.Hook),
    rule: Pegasus.ruleSchema,
    createdOn: z.string(),
});
export const storeRuleUpdate = storeRule.omit({ createdOn: true });
export const storeRuleCreate = storeRule.omit({ id: true, createdOn: true });
// ---------- Array Fact Data (Pegasus) ------------
const labeledFactValueSchema = (fact) => {
    // ! EXPLICIT TYPE ASSERTION; this narrows the type to the specific fact passed
    const value = Pegasus.valueSchemaForFact(fact).element;
    const option = z.object({ label: z.string(), value });
    return z.union([
        // flat options
        z.array(option),
        // grouped options
        z.array(z.object({
            label: z.string(),
            options: z.array(option),
        })),
    ]);
};
// TODO determine if there's a better way to generate this; however, it thankfully is explicit
export const arrayFactData = z.object({
    [Pegasus.ArrayFactType.arbitrary]: z.object({
        [Pegasus.Fact.orderTags]: Pegasus.valueSchemaForFact(Pegasus.Fact.orderTags),
        [Pegasus.Fact.orderShippingLineTitle]: Pegasus.valueSchemaForFact(Pegasus.Fact.orderShippingLineTitle),
        [Pegasus.Fact.customerTags]: Pegasus.valueSchemaForFact(Pegasus.Fact.customerTags),
        [Pegasus.Fact.rmaStatus]: Pegasus.valueSchemaForFact(Pegasus.Fact.rmaStatus),
        [Pegasus.Fact.productTags]: Pegasus.valueSchemaForFact(Pegasus.Fact.productTags),
        [Pegasus.Fact.productTypes]: Pegasus.valueSchemaForFact(Pegasus.Fact.productTypes),
        [Pegasus.Fact.productCollections]: Pegasus.valueSchemaForFact(Pegasus.Fact.productCollections),
        [Pegasus.Fact.orderNumber]: Pegasus.valueSchemaForFact(Pegasus.Fact.orderNumber),
        [Pegasus.Fact.customerEmail]: Pegasus.valueSchemaForFact(Pegasus.Fact.customerEmail),
        [Pegasus.Fact.orderDiscountCode]: Pegasus.valueSchemaForFact(Pegasus.Fact.orderDiscountCode),
        [Pegasus.Fact.productVendor]: Pegasus.valueSchemaForFact(Pegasus.Fact.productVendor),
        [Pegasus.Fact.productSku]: Pegasus.valueSchemaForFact(Pegasus.Fact.productSku),
        [Pegasus.Fact.intelligemsTestGroupId]: Pegasus.valueSchemaForFact(Pegasus.Fact.intelligemsTestGroupId),
        [Pegasus.Fact.orderLineItemCustomPropertyName]: Pegasus.valueSchemaForFact(Pegasus.Fact.orderLineItemCustomPropertyName),
        [Pegasus.Fact.claimTags]: Pegasus.valueSchemaForFact(Pegasus.Fact.claimTags),
        [Pegasus.Fact.shippingClaimLineItemReorderSku]: Pegasus.valueSchemaForFact(Pegasus.Fact.shippingClaimLineItemReorderSku),
    }),
    [Pegasus.ArrayFactType.definite]: z.object({
        [Pegasus.Fact.orderCountry]: labeledFactValueSchema(Pegasus.Fact.orderCountry),
        [Pegasus.Fact.shippingClaimResolutionMethod]: labeledFactValueSchema(Pegasus.Fact.shippingClaimResolutionMethod),
        [Pegasus.Fact.userRole]: labeledFactValueSchema(Pegasus.Fact.userRole),
        [Pegasus.Fact.orderProvince]: labeledFactValueSchema(Pegasus.Fact.orderProvince),
        [Pegasus.Fact.claimLineItemRequestedResolutionMethod]: labeledFactValueSchema(Pegasus.Fact.claimLineItemRequestedResolutionMethod),
        [Pegasus.Fact.returnShipmentStatus]: labeledFactValueSchema(Pegasus.Fact.returnShipmentStatus),
        [Pegasus.Fact.reasonId]: labeledFactValueSchema(Pegasus.Fact.reasonId),
        [Pegasus.Fact.reasonCategoryCode]: labeledFactValueSchema(Pegasus.Fact.reasonCategoryCode),
        [Pegasus.Fact.reasonDetailId]: labeledFactValueSchema(Pegasus.Fact.reasonDetailId),
        [Pegasus.Fact.claimType]: labeledFactValueSchema(Pegasus.Fact.claimType),
        [Pegasus.Fact.orderChannel]: labeledFactValueSchema(Pegasus.Fact.orderChannel),
        [Pegasus.Fact.claimLineItemCustomFieldResponse]: labeledFactValueSchema(Pegasus.Fact.claimLineItemCustomFieldResponse),
        [Pegasus.Fact.orderGateway]: labeledFactValueSchema(Pegasus.Fact.orderGateway),
        [Pegasus.Fact.registrationChannel]: labeledFactValueSchema(Pegasus.Fact.registrationChannel),
        [Pegasus.Fact.orderFulfillmentLocationId]: labeledFactValueSchema(Pegasus.Fact.orderFulfillmentLocationId),
        [Pegasus.Fact.productGroupId]: labeledFactValueSchema(Pegasus.Fact.productGroupId),
        [Pegasus.Fact.customerSegmentId]: labeledFactValueSchema(Pegasus.Fact.customerSegmentId),
        [Pegasus.Fact.orderFulfillmentDisplayStatus]: labeledFactValueSchema(Pegasus.Fact.orderFulfillmentDisplayStatus),
        [Pegasus.Fact.orderFinancialStatus]: labeledFactValueSchema(Pegasus.Fact.orderFinancialStatus),
        [Pegasus.Fact.claimLineItemInspectionGrade]: labeledFactValueSchema(Pegasus.Fact.claimLineItemInspectionGrade),
        [Pegasus.Fact.returnShipmentLocationId]: labeledFactValueSchema(Pegasus.Fact.returnShipmentLocationId),
        [Pegasus.Fact.rmaDisposition]: labeledFactValueSchema(Pegasus.Fact.rmaDisposition),
        [Pegasus.Fact.claimRiskLevel]: labeledFactValueSchema(Pegasus.Fact.claimRiskLevel),
        [Pegasus.Fact.shippingClaimReason]: labeledFactValueSchema(Pegasus.Fact.shippingClaimReason),
    }),
});
//# sourceMappingURL=storeRule.js.map